import React from "react";
import { useSearchParams } from "react-router-dom";
import { Button } from "primereact/button";
import Ledger, { Home } from "./Ledger";
import Detail from "./Detail";
import Catalog from "./Catalog";
import Reports from "./Reports";
import Inventory from "./Inventory";
import MovementForm from "./MovementForm";
import { Status, useData } from "./common";
import "./supplyDispatch.css";
function ExistingForm({ mode, id, ...props }) {
  const state = useData("movimientos/" + id);
  return state.data ? (
    <MovementForm mode={mode} source={state.data} {...props} />
  ) : (
    <Status {...state} />
  );
}
export default function SupplyDispatch({ access }) {
  const [query, setQuery] = useSearchParams();
  const requestedView = query.get("view") || "home";
  const view = ["prepared", "edit"].includes(requestedView)
      ? "history"
      : requestedView,
    id = query.get("id"),
    actions = access.actions || [];
  const go = (next, selected) =>
    setQuery({ view: next, ...(selected ? { id: selected } : {}) });
  const detail = (selected) => go("detail", selected),
    form = (mode, m) => go(mode, m._id);
  if (access.loading) return <p>Cargando permisos…</p>;
  if (!actions.includes("ver"))
    return (
      <p role="alert">
        {access.error || "No tiene acceso a Despacho de Insumos."}
      </p>
    );
  const operate = actions.includes("operar"),
    mayForm = ["new", "request", "return", "dispose"].includes(view)
      ? operate && (view !== "request" || access.canRequest === true)
      : view === "adjust"
      ? actions.includes("anular")
      : false;
  const formProps = {
    onSaved: (m) => detail(m._id),
    onClose: () => (id ? detail(id) : go("home")),
  };
  return (
    <main className="sd-module card">
      <h1>Despacho de Insumos</h1>
      <nav aria-label="Despacho de Insumos" className="sd-toolbar">
        {[
          ["home", "Inicio"],
          ...(operate
            ? [
                ["new", "Nuevo despacho"],
                ...(access.canRequest ? [["request", "Solicitud de Pedido - Operador"]] : []),
                ["return", "Devolución"],
                ["dispose", "Desincorporación"],
              ]
            : []),
          ["history", "Histórico"],
          ["operator-history", "Historico - Operador"],
          ["reports", "Reportes"],
          ["inventory", "Inventario"],
          ["insumos", "Insumos"],
          ["destinos", "Destinos"],
        ].map(([key, title]) => (
          <Button
            key={key}
            label={title}
            className={view === key ? "" : "p-button-outlined"}
            onClick={() => go(key)}
          />
        ))}
      </nav>
      {view === "home" && (
        <Home onDetail={detail} go={go} canOperate={operate} canRequest={access.canRequest === true} />
      )}
      {view === "history" && <Ledger onDetail={detail} />}
      {view === "operator-history" && <Ledger key="operator-history" operatorOnly onDetail={detail} />}
      {view === "detail" && id && (
        <Detail
          key={id}
          id={id}
          actions={actions}
          onForm={form}
          onDetail={detail}
        />
      )}
      {["insumos", "destinos"].includes(view) && (
        <Catalog
          key={view}
          kind={view}
          canEdit={actions.includes("catalogo_" + view)}
        />
      )}
      {view === "reports" && <Reports />}
      {view === "inventory" && <Inventory canOperate={operate} canRequest={access.canRequest === true} />}
      {mayForm &&
        (id ? (
          <ExistingForm key={view + id} mode={view} id={id} {...formProps} />
        ) : view === "adjust" ? (
          <p>Seleccione un movimiento desde el histórico.</p>
        ) : (
          <MovementForm key={view} mode={view} {...formProps} />
        ))}
      {["new", "request", "return", "dispose", "adjust"].includes(view) && !mayForm && (
        <p role="alert">No tiene permiso para esta acción.</p>
      )}
    </main>
  );
}

